import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDrink: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDrink"><Path fillRule="evenodd" clipRule="evenodd" d="M17.6936 2.75926L13.0005 3.80217V6H19.0694L17.9361 23H6.06497L4.93164 6H11.0005V2.19783L17.2598 0.806885L17.6936 2.75926ZM16.7316 11H7.26941L7.06941 8H16.9316L16.7316 11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDrink;
